const createContext = function createContext(audioContextWrapper) {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();
    audioContextWrapper.isReady = true;
    audioContextWrapper.getContext = () => audioContext;
    return audioContext;
  } catch (err) {
    return null;
  }
};

const createAudioContextWrapper = function () {
  const audioContextWrapper = {
    isReady: false,
    getContext: () => createContext.call(this),
  };
  audioContextWrapper.getContext = () => createContext.call(this, audioContextWrapper);

  return audioContextWrapper;
};

export { createAudioContextWrapper };
